import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";
import Select from "react-select";
import { smallFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";

function TaskMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [dependantTaskList, setDependantTaskList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // ---------- Add form state ----------
  const [addName, setAddName] = useState("");
  const [addSubTaskName, setAddSubTaskName] = useState("");
  const [addType, setAddType] = useState("EXPORT");
  const [addCargoType, setAddCargoType] = useState("NON_HAZARDOUS");
  const [addCountry, setAddCountry] = useState("");
  const [addZone, setAddZone] = useState("NONE");
  const [addPoaPortType, setAddPoaPortType] = useState("SEA");
  const [addIsMandatory, setAddIsMandatory] = useState("YES");
  const [addIsTerminalSpecific, setAddIsTerminalSpecific] = useState("NO");
  const [addTerminal, setAddTerminal] = useState("");
  const [addDependantOn, setAddDependantOn] = useState([]);
  const [addSequence, setAddSequence] = useState("");
  const [addTaskAssigneeRole, setAddTaskAssigneeRole] = useState("NONE");
  const [addQuickNotification, setAddQuickNotification] = useState("NO");
  const [addStatus, setAddStatus] = useState("ACTIVE");

  // Add field errors
  const [showAddNameError, setShowAddNameError] = useState(false);
  const [showAddSubTaskNameError, setShowAddSubTaskNameError] = useState(false);
  const [showAddTypeError, setShowAddTypeError] = useState(false);
  const [showAddCargoTypeError, setShowAddCargoTypeError] = useState(false);
  const [showAddCountryError, setShowAddCountryError] = useState(false);
  const [showAddSequenceError, setShowAddSequenceError] = useState(false);
  const [showAddTaskAssigneeRoleError, setShowAddTaskAssigneeRoleError] = useState(false);

  // Add validation summary
  const [showAddValidationError, setShowAddValidationError] = useState(false);
  const [addValidationErrorArray, setAddValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] = useState(false);

  // ---------- Update form state ----------
  const [updateId, setUpdateId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateSubTaskName, setUpdateSubTaskName] = useState("");
  const [updateType, setUpdateType] = useState("EXPORT");
  const [updateCargoType, setUpdateCargoType] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const [updateZone, setUpdateZone] = useState("NONE");
  const [updatePoaPortType, setUpdatePoaPortType] = useState("SEA");
  const [updateIsMandatory, setUpdateIsMandatory] = useState("YES");
  const [updateIsTerminalSpecific, setUpdateIsTerminalSpecific] = useState("NO");
  const [updateTerminal, setUpdateTerminal] = useState("");
  const [updateDependantOn, setUpdateDependantOn] = useState([]);
  const [updateSequence, setUpdateSequence] = useState("");
  const [updateTaskAssigneeRole, setUpdateTaskAssigneeRole] = useState("");
  const [updateQuickNotification, setUpdateQuickNotification] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");

  // Update field errors
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateSubTaskNameError, setShowUpdateSubTaskNameError] = useState(false);
  const [showUpdateTypeError, setShowUpdateTypeError] = useState(false);
  const [showUpdateCargoTypeError, setShowUpdateCargoTypeError] = useState(false);
  const [showUpdateCountryError, setShowUpdateCountryError] = useState(false);
  const [showUpdateSequenceError, setShowUpdateSequenceError] = useState(false);
  const [showUpdateTaskAssigneeRoleError, setShowUpdateTaskAssigneeRoleError] = useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] = useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState([]);
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] = useState(false);

  // ========== Validation Helpers ==========
  const isNumeric = (val) => /^\d+$/.test(val); // positive integers only

  // ========== Real‑time error helpers for Add ==========
  const hasAnyAddError = () => {
    setShowAddValidationError(
      showAddNameError || 
      showAddSubTaskNameError || 
      showAddTypeError ||
      showAddCargoTypeError ||
      showAddCountryError || 
      showAddTaskAssigneeRoleError ||
      showAddSequenceError
    )

    return (
      showAddNameError || 
      showAddSubTaskNameError || 
      showAddTypeError ||
      showAddCargoTypeError ||
      showAddCountryError || 
      showAddTaskAssigneeRoleError ||
      showAddSequenceError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addName) errors.push("Name is required");
    if (!addSubTaskName) errors.push("Sub Task Name is required");
    if (!addType) errors.push("Type is required");
    if (!addCargoType) errors.push("Cargo Type is required");
    if (!addCountry) errors.push("Country is required");
    if (!addTaskAssigneeRole) errors.push("Role is required");
    if (!addSequence) errors.push("Sequence is required");
    else if (!isNumeric(addSequence))
      errors.push("Sequence must contain only digits");
    return errors;
  };

  // ========== Real‑time error helpers for Update ==========
  const hasAnyUpdateError = () => {
    return (
      showUpdateNameError ||
      showUpdateSubTaskNameError ||
      showUpdateTypeError ||
      showUpdateCargoTypeError ||
      showUpdateCountryError || 
      showUpdateTaskAssigneeRoleError || 
      showUpdateSequenceError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateName) errors.push("Name is required");
    if (!updateSubTaskName) errors.push("Sub Task Name is required");
    if (!updateType) errors.push("Type is required");
    if (!updateCargoType) errors.push("Cargo Type is required");
    if (!updateCountry) errors.push("Country is required");
    if (!updateTaskAssigneeRole) errors.push("Role is required");
    if (!updateSequence) errors.push("Sequence is required");
    else if (!isNumeric(updateSequence))
      errors.push("Sequence must contain only digits");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () => setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () => setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getTask = async () => {
    try {
      setDataPending(true);
      // const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + "/master/task/");
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + "/master/task/getcountrywisetask");      
      const sorted_data = response?.data?.results.sort((a, b) => a.country.country__long_name - b.country.country__long_name);
      setData(sorted_data);
    } catch (err) {
      toast.error("Error in fetching task data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const country_data = response.data;
      const sorted_data = country_data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      const country_name_list =
        sorted_data?.map((item) => ({
          value: item.id,
          label: item.long_name,
        })) || [];
      setCountryList(country_name_list);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getTerminal = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/terminal/",
      );
      const terminal_data = response.data;
      const sorted_data = terminal_data.sort((a, b) => a.object_id - b.object_id,);

      const terminal_name_list =
        sorted_data?.map((item) => ({
          value: item.id,
          label: item.name + " (" + item.port_data.name + ")",
        })) || [];
      setTerminalList(terminal_name_list);
    } catch (err) {
      toast.error("Error in fetching terminal data! Try again.");
    }
  };

  const getDependantTask = async (country_id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + "/master/task?country__id="+country_id);
      const task_data = response.data;
      const sorted_data = task_data.sort((a, b) => a.object_id - b.object_id,);

      const task_name_list =
        sorted_data?.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.sub_task_name + " (" + item.type + ")",
        })) || [];
      setDependantTaskList(task_name_list);
    } catch (err) {
      toast.error("Error in fetching task data! Try again.");
    }
  };

  const getRole = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/role/",
      );
      const role_data = response.data;
      const sorted_data = role_data.sort(
        (a, b) => a.role - b.role,
      );
      setRoleList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getTask();
    getCountry();
    getTerminal();
    getRole();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/master/task/" + id + "/",
      );
      setShowDeleteModal(false);
      getTask();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setAddName("");
    setAddSubTaskName("");
    setAddType("EXPORT");
    setAddCargoType("NON_HAZARDOUS");
    setAddCountry("");
    setAddZone("NONE");
    setAddPoaPortType("SEA");
    setAddIsMandatory("YES");
    setAddIsTerminalSpecific("NO");
    setAddTerminal("");
    setAddDependantOn([]);
    setAddSequence("");
    setAddTaskAssigneeRole("NONE");
    setAddQuickNotification("NO");
    setAddStatus("ACTIVE");

    setShowAddNameError(false);
    setShowAddSubTaskNameError(false);
    setShowAddTypeError(false);
    setShowAddCargoTypeError(false);
    setShowAddCountryError(false);
    setShowAddSequenceError(false);
    setShowAddTaskAssigneeRoleError(false);
    setShowAddValidationError(false);
    setAddValidationErrorArray([]);
    setIsValidationErrorVisible(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewTask = async (e) => {
    e.preventDefault();

    setShowAddNameError(!addName);
    setShowAddSubTaskNameError(!addSubTaskName);
    setShowAddTypeError(!addType);
    setShowAddCargoTypeError(!addCargoType);
    setShowAddCountryError(!addCountry);
    setShowAddSequenceError(!addSequence || !isNumeric(addSequence));
    setShowAddTaskAssigneeRoleError(!addTaskAssigneeRole);
    setAddValidationErrorArray(buildAddErrorMessages());

    if (
      !addName ||
      !addSubTaskName ||
      !addType ||
      !addCargoType ||
      !addCountry ||
      !addTaskAssigneeRole ||
      !addSequence ||
      !isNumeric(addSequence)
    ) {
      setShowAddValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      name: addName,
      sub_task_name: addSubTaskName,
      type: addType,
      cargo_type: addCargoType,
      country: addCountry?.value,
      zone: addZone,
      poa_port_type: addPoaPortType,
      is_mandatory: addIsMandatory,
      is_terminal_specific: addIsTerminalSpecific,
      terminal: addTerminal,
      dependant_on: addDependantOn,
      sequence: addSequence,
      task_assignee_role: addTaskAssigneeRole,
      quick_notification: addQuickNotification,
      status: addStatus,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/task/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Task Created Successfully");
        handleAddModalClose();
        getTask();
      }
    } catch (err) {
      toast.error("Error creating task");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateName("");
    setUpdateSubTaskName("");
    setUpdateType("EXPORT");
    setUpdateCargoType("NON_HAZARDOUS");
    setUpdateCountry("");
    setUpdateZone("NONE");
    setUpdatePoaPortType("SEA");
    setUpdateIsMandatory("YES");
    setUpdateIsTerminalSpecific("NO");
    setUpdateTerminal("");
    setUpdateDependantOn([]);
    setUpdateSequence("");
    setUpdateTaskAssigneeRole("NONE");
    setUpdateQuickNotification("NO");
    setUpdateStatus("ACTIVE");

    setShowUpdateNameError(false);
    setShowUpdateSubTaskNameError(false);
    setShowUpdateTypeError(false);
    setShowUpdateCargoTypeError(false);
    setShowUpdateCountryError(false);
    setShowUpdateSequenceError(false);
    setShowUpdateTaskAssigneeRoleError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.task_data?.task_data?.id);
    setUpdateName(row.task_data?.name);
    setUpdateSubTaskName(row.task_data?.sub_task_name);
    setUpdateType(row.task_data?.type);
    setUpdateCargoType(row.task_data?.cargo_type);
    setUpdateCountry({"value": row.task_data?.country_data?.id, "label": row.task_data?.country_data?.long_name});
    setUpdateZone(row.task_data?.zone);
    setUpdatePoaPortType(row.task_data?.poa_port_type);
    setUpdateIsMandatory(row.task_data?.is_mandatory);
    setUpdateIsTerminalSpecific(row.task_data?.is_terminal_specific);
    setUpdateTerminal(row.task_data?.terminal);
    setUpdateDependantOn(row.task_data?.dependant_on);
    setUpdateSequence(row.task_data?.sequence);
    setUpdateTaskAssigneeRole(row.task_data?.task_asignee_role);
    setUpdateQuickNotification(row.task_data?.quick_notification);
    setUpdateStatus(row.task_data?.status);

    // Reset errors
    setShowUpdateNameError(false);
    setShowUpdateSubTaskNameError(false);
    setShowUpdateTypeError(false);
    setShowUpdateCargoTypeError(false);
    setShowUpdateCountryError(false);
    setShowUpdateSequenceError(false);
    setShowUpdateTaskAssigneeRoleError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
  };

  const updateTask = async (e) => {
    e.preventDefault();

    setShowUpdateNameError(!updateName);
    setShowUpdateSubTaskNameError(!updateSubTaskName);
    setShowUpdateTypeError(!updateType);
    setShowUpdateCargoTypeError(!updateCargoType);
    setShowUpdateCountryError(!updateCountry);
    setShowUpdateSequenceError(!updateSequence || !isNumeric(updateSequence));
    setShowUpdateTaskAssigneeRoleError(!updateTaskAssigneeRole);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateName ||
      !updateSubTaskName ||
      !updateType ||
      !updateCargoType ||
      !updateCountry ||
      !updateTaskAssigneeRole ||
      !updateSequence ||
      !isNumeric(updateSequence)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      name: updateName,
      sub_task_name: updateSubTaskName,
      type: updateType,
      cargo_type: updateCargoType,
      country: updateCountry?.value,
      zone: updateZone,
      poa_port_type: updatePoaPortType,
      is_mandatory: updateIsMandatory,
      is_terminal_specific: updateIsTerminalSpecific,
      terminal: updateTerminal,
      dependant_on: updateDependantOn,
      sequence: updateSequence,
      task_assignee_role: updateTaskAssigneeRole,
      quick_notification: updateQuickNotification,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/task/" +
          updateId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Task Updated Successfully");
        handleUpdateModalClose();
        getTask();
      }
    } catch (err) {
      toast.error("Error updating task");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Table columns ==========
  const getMandatoryTaskCount = (data) => {
    return data.filter(t => t.task_data?.is_mandatory === "YES").length;
  };

  const getNonMandatoryTaskCount = (data) => {
    return data.filter(t => t.task_data?.is_mandatory === "NO").length;
  };

  const countrywisetaskcolumns = [
    {
      id: 'country',
      name: 'Country',
      width: '200px',
      selector: row => row.country?.country__long_name,
    },
    {
      id: 'type',
      name: 'Type',
      width: '200px',
      selector: row => row.country?.trade_type,
    },
    {
      id: 'total',
      name: 'Total Tasks',
      width: '200px',
      selector: row => row.country?.total_tasks,
    },
    {
      id: 'mandatory_tasks',
      name: 'Mandatory Tasks',
      width: '200px',
      selector: row => getMandatoryTaskCount(row.tasks),
    },
    {
      id: 'non_mandatory_tasks',
      name: 'Non Mandatory Tasks',
      width: '200px',
      selector: row => getNonMandatoryTaskCount(row.tasks),
    }
  ]

  const ExpandedCountryWiseTaskComponent = ({ data }) => {
    const columns = [
      { name: "Sequence", width: "110px", selector: (row) => row.task_data?.sequence, sortable: true },
      { name: "Name", width: "250px", selector: (row) => 
          <>
            <span><b>Task: </b> {row.task_data?.name}</span><br></br>
            <span><b>Sub Task: </b> {row.task_data?.sub_task_name}</span>
            <span></span>
          </>,
        sortable: true 
      },
      { name: "Cargo Type", width: "150px", selector: (row) => row.task_data?.cargo_type?.replaceAll("_", " "), sortable: true },
      { name: "Zone", selector: (row) => row.task_data?.zone, sortable: true },
      { name: "POA Port", selector: (row) => row.task_data?.poa_port_type, sortable: true },
      { name: "Mandatory", selector: (row) => 
          <span className={`${row.task_data?.is_mandatory == "YES"? "bg-success text-white": "bg-muted"} px-2 rounded`}>
            {row.task_data?.is_mandatory}
          </span>, 
          sortable: true 
      },
      { name: "Terminal Specific", selector: (row) => row.task_data?.is_terminal_specific, sortable: true },
      { name: "Terminal", selector: (row) => row.task_data?.terminal, sortable: true },
      { name: "Assigned To", width: "150px", selector: (row) => row.task_data?.task_assignee_role, sortable: true },
      { name: "Status", selector: (row) => row.task_data?.status, sortable: true },
      {
        name: "Action",
        center: true,
        selector: (row) => (
          <div>
            {currentUserRolePermissionData?.includes("master:task:update") && (
              <Button
                className="btn btn-sm btn-inox-green border-0"
                title="Update"
                onClick={() => {
                  handleSetUpdateData(row);
                  setShowUpdateCanvas(true);
                }}
              >
                <i className="fa fa-edit"></i>
              </Button>
            )}
            {currentUserRolePermissionData?.includes("master:task:delete") && (
              <Button
                className="btn btn-sm bg-danger border-0 mx-2"
                title="Delete"
                onClick={() => handleDeleteModalOpen(row)}
              >
                <i className="fa fa-trash"></i>
              </Button>
            )}
          </div>
        ),
      },
    ];

    return (
      <div className="col-12 text-left" style={{ marginTop: -10, paddingLeft: 48, paddingRight: 0, zIndex: 100 }}>
        <DataTable
          columns={columns}
          data={data?.tasks || []}
          progressPending={dataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No Tasks Found</p>}
          highlightOnHover
          customStyles={userTableCustomStyles}
          dense
          pagination
        />
      </div>
    )
  }

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="TaskMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Task Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:task:add") ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Task</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={countrywisetaskcolumns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
            expandableRows
            expandableRowsComponent={ExpandedCountryWiseTaskComponent}
          />
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.task_data?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Task
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={updateTask}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_name">
                  Name:
                  <span className="text-danger">
                    {showUpdateNameError ? " required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_name"
                  placeholder="Enter Task Name"
                  value={updateName}
                  onChange={(e) => {
                    setUpdateName(e.target.value);
                    setShowUpdateNameError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateNameError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Sub Task Name */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_sub_task_name">
                  Sub Task Name:
                  <span className="text-danger">
                    {showUpdateSubTaskNameError ? " required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_sub_task_name"
                  placeholder="Enter Sub Task Name"
                  value={updateSubTaskName}
                  onChange={(e) => {
                    setUpdateSubTaskName(e.target.value);
                    setShowUpdateSubTaskNameError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateSubTaskNameError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Type */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_type">Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_type"
                  value={updateType}
                  onChange={(e) => {
                    setUpdateType(e.target.value);
                    setShowUpdateTypeError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateTypeError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  <option value="EXPORT" selected={updateType=="EXPORT"?true:false}>EXPORT</option>
                  <option value="IMPORT" selected={updateType=="IMPORT"?true:false}>IMPORT</option>
                  <option value="TSP" selected={updateType=="TSP"?true:false}>TSP</option>
                </select>
              </div>

              {/* Cargo Type */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_cargo_type">Cargo Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_cargo_type"
                  value={updateCargoType}
                  onChange={(e) => {
                    setUpdateCargoType(e.target.value);
                    setShowUpdateCargoTypeError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateCargoTypeError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  <option value="HAZARDOUS" selected={updateCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                  <option value="NON_HAZARDOUS" selected={updateCargoType=="NON_HAZARDOUS"?true:false}>NON_HAZARDOUS</option>
                </select>
              </div>

              {/* Country */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_cargo_type">Country:</label>
                <Select
                  options={countryList}
                  id="country"
                  name="country"
                  onChange={(e) => {
                    setUpdateCountry(e);
                    setShowUpdateCountryError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    getDependantTask(e?.value)
                  }}
                  onBlur={(e) => {
                    setShowUpdateCountryError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  value={updateCountry}
                  isMulti={false}
                  styles={smallFormSelectCustomStyles}
                />
              </div>

              {/* Zone */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_zone">Zone:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_zone"
                  value={updateZone}
                  onChange={(e) => setUpdateZone(e.target.value)}
                >
                  <option value="NORTH" selected={updateZone=="NORTH"?true:false}>NORTH</option>
                  <option value="SOUTH" selected={updateZone=="SOUTH"?true:false}>SOUTH</option>
                  <option value="EAST" selected={updateZone=="EAST"?true:false}>EAST</option>
                  <option value="WEST" selected={updateZone=="WEST"?true:false}>WEST</option>
                  <option value="NONE" selected={updateZone=="NONE"?true:false}>NONE</option>
                </select>
              </div>

              {/* POA Type */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_poa_port_type">POA Port Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_poa_port_type"
                  value={updatePoaPortType}
                  onChange={(e) => setUpdatePoaPortType(e.target.value)}
                >
                  <option value="SEA" selected={updatePoaPortType=="SEA"?true:false}>SEA</option>
                  <option value="DRY" selected={updatePoaPortType=="DRY"?true:false}>DRY</option>
                </select>
              </div>

              {/* Is Mandatory */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_is_mandatory">Is Mandatory Task:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_is_mandatory"
                  value={updateIsMandatory}
                  onChange={(e) => setUpdateIsMandatory(e.target.value)}
                >
                  <option value="YES" selected={updateIsMandatory=="YES"?true:false}>YES</option>
                  <option value="NO" selected={updateIsMandatory=="NO"?true:false}>NO</option>
                </select>
              </div>

              {/* Is Terminal Specific */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_is_terminal_specific">Is Terminal Specific Task:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_is_terminal_specific"
                  value={updateIsTerminalSpecific}
                  onChange={(e) => setUpdateIsTerminalSpecific(e.target.value)}
                >
                  <option value="YES" selected={updateIsTerminalSpecific=="YES"?true:false}>YES</option>
                  <option value="NO" selected={updateIsTerminalSpecific=="NO"?true:false}>NO</option>
                </select>
              </div>

              {/* Terminal */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_cargo_type">Terminal:</label>
                <Select
                  options={terminalList}
                  id="terminal"
                  name="terminal"
                  onChange={(e) => {
                    setUpdateTerminal(e);
                  }}
                  value={updateTerminal}
                  isMulti={true}
                  styles={smallFormSelectCustomStyles}
                />
              </div>

              {/* Sequence */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_sequence">
                  Sequence:
                  <span className="text-danger">
                    {showUpdateSequenceError
                      ? updateSequence
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="update_sequence"
                  placeholder="Enter Sequence"
                  value={updateSequence}
                  onChange={(e) => {
                    setUpdateSequence(e.target.value);
                    setShowUpdateSequenceError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateSequenceError(!val || !isNumeric(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Dependant On */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_cargo_type">Dependant On:</label>
                <Select
                  options={dependantTaskList}
                  id="update_dependant_on"
                  name="update_dependant_on"
                  onChange={(e) => {
                    setUpdateDependantOn(e);
                  }}
                  value={updateDependantOn}
                  isMulti={true}
                  styles={smallFormSelectCustomStyles}
                />
              </div>

              {/* Assigned To Role */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_task_assignee_role">Assigned To Role:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_task_assignee_role"
                  value={updateTaskAssigneeRole}
                  onChange={(e) => {
                    setUpdateTaskAssigneeRole(e.target.value);
                    setShowUpdateTaskAssigneeRoleError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateTaskAssigneeRoleError(!val);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  {roleList.map(role => (
                    <option value={role.role_name} selected={updateTaskAssigneeRole==role.id?true:false}>{role.role_name}</option>
                  ))}
                </select>
              </div>

              {/* Quick Notification */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_quick_notification">Quick Notification:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_quick_notification"
                  value={updateQuickNotification}
                  onChange={(e) => setUpdateQuickNotification(e.target.value)}
                >
                  <option value="YES" selected={updateQuickNotification=="YES"?true:false}>YES</option>
                  <option value="NO" selected={updateQuickNotification=="NO"?true:false}>NO</option>
                </select>
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_status">Status:</label>
                <select
                  className="form-select form-control-sm"
                  id="update_status"
                  value={updateStatus}
                  onChange={(e) => setUpdateStatus(e.target.value)}
                >
                  <option value="ACTIVE" selected={updateStatus=="ACTIVE"?true:false}>ACTIVE</option>
                  <option value="INACTIVE" selected={updateStatus=="INACTIVE"?true:false}>INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyUpdateError() || showUpdateLoader}
                  >
                    {showUpdateLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-edit"></i>{" "}
                        <span className="mx-2">Update</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyUpdateError() || showUpdateValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleUpdateCheckValidationClick}
                        onMouseLeave={() =>
                          setIsUpdateValidationErrorVisible(false)
                        }
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isUpdateValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {updateValidationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Task
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={addNewTask}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_name">
                  Name:
                  <span className="text-danger">
                    {showAddNameError ? " required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_name"
                  placeholder="Enter Task Name"
                  value={addName}
                  onChange={(e) => {
                    setAddName(e.target.value);
                    setShowAddNameError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddNameError(e.target.value === "");
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Sub Task Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_sub_task_name">
                  Sub Task Name:
                  <span className="text-danger">
                    {showAddSubTaskNameError ? " required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_description"
                  placeholder="Enter Description"
                  value={addSubTaskName}
                  onChange={(e) => {
                    setAddSubTaskName(e.target.value);
                    setShowAddSubTaskNameError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddSubTaskNameError(e.target.value === "");
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Type */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_type">Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_type"
                  value={addType}
                  onChange={(e) => {
                    setAddType(e.target.value);
                    setShowAddTypeError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddTypeError(e.target.value === "");
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="EXPORT" selected={addType=="EXPORT"?true:false}>EXPORT</option>
                  <option value="IMPORT" selected={addType=="IMPORT"?true:false}>IMPORT</option>
                  <option value="TSP" selected={addType=="TSP"?true:false}>TSP</option>
                </select>
              </div>

              {/* Cargo Type */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_cargo_type">Cargo Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_cargo_type"
                  value={addCargoType}
                  onChange={(e) => {
                    setAddCargoType(e.target.value);
                    setShowAddCargoTypeError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddCargoTypeError(e.target.value === "");
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="HAZARDOUS" selected={addCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                  <option value="NON_HAZARDOUS" selected={addCargoType=="NON_HAZARDOUS"?true:false}>NON HAZARDOUS</option>
                </select>
              </div>

              {/* Country */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_cargo_type">Country:</label>
                <Select
                  options={countryList}
                  id="country"
                  name="country"
                  onChange={(e) => {
                    setAddCountry(e);
                    setShowAddCountryError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                    getDependantTask(e?.value)
                  }}
                  onBlur={(e) => {
                    setShowAddCountryError(e.target.value === "");
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  value={addCountry}
                  isMulti={false}
                  styles={smallFormSelectCustomStyles}
                />
              </div>

              {/* Zone */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_zone">Zone:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_zone"
                  value={addZone}
                  onChange={(e) => setAddZone(e.target.value)}
                >
                  <option value="NORTH" selected={addZone=="NORTH"?true:false}>NORTH</option>
                  <option value="SOUTH" selected={addZone=="SOUTH"?true:false}>SOUTH</option>
                  <option value="EAST" selected={addZone=="EAST"?true:false}>EAST</option>
                  <option value="WEST" selected={addZone=="WEST"?true:false}>WEST</option>
                  <option value="NONE" selected={addZone=="NONE"?true:false}>NONE</option>
                </select>
              </div>

              {/* POA Type */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_poa_port_type">POA Port Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_poa_port_type"
                  value={addPoaPortType}
                  onChange={(e) => setAddPoaPortType(e.target.value)}
                >
                  <option value="SEA" selected={addPoaPortType=="SEA"?true:false}>SEA</option>
                  <option value="DRY" selected={addPoaPortType=="DRY"?true:false}>DRY</option>
                </select>
              </div>

              {/* Is Mandatory */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_is_mandatory">Is Mandatory Task:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_is_mandatory"
                  value={addIsMandatory}
                  onChange={(e) => setAddIsMandatory(e.target.value)}
                >
                  <option value="YES" selected={addIsMandatory=="YES"?true:false}>YES</option>
                  <option value="NO" selected={addIsMandatory=="NO"?true:false}>NO</option>
                </select>
              </div>

              {/* Is Terminal Specific */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_is_terminal_specific">Is Terminal Specific Task:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_is_terminal_specific"
                  value={addIsTerminalSpecific}
                  onChange={(e) => setAddIsTerminalSpecific(e.target.value)}
                >
                  <option value="YES" selected={addIsTerminalSpecific=="YES"?true:false}>YES</option>
                  <option value="NO" selected={addIsTerminalSpecific=="NO"?true:false}>NO</option>
                </select>
              </div>

              {/* Terminal */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_cargo_type">Terminal:</label>
                <Select
                  options={terminalList}
                  id="terminal"
                  name="terminal"
                  onChange={(e) => {
                    setAddTerminal(e);
                  }}
                  value={addTerminal}
                  isMulti={true}
                  styles={smallFormSelectCustomStyles}
                  isDisabled={addIsTerminalSpecific=="NO"?true:false}
                />
              </div>

              {/* Sequence */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_sequence">
                  Sequence:
                  <span className="text-danger">
                    {showAddSequenceError
                      ? addSequence
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  id="add_sequence"
                  placeholder="Enter Sequence"
                  value={addSequence}
                  onChange={(e) => {
                    setAddSequence(e.target.value);
                    setShowAddSequenceError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowAddSequenceError(!val || !isNumeric(val));
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Dependant On */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_cargo_type">Dependant On:</label>
                <Select
                  options={dependantTaskList}
                  id="add_dependant_on"
                  name="add_dependant_on"
                  onChange={(e) => {
                    setAddDependantOn(e);
                  }}
                  value={addDependantOn}
                  isMulti={true}
                  styles={smallFormSelectCustomStyles}
                />
              </div>

              {/* Assigned To Role */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_task_assignee_role">Assigned To Role:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_task_assignee_role"
                  value={addTaskAssigneeRole}
                  onChange={(e) => {
                    setAddTaskAssigneeRole(e.target.value);
                    setShowAddTaskAssigneeRoleError(false);
                    setShowAddValidationError(false);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowAddTaskAssigneeRoleError(!val);
                    setAddValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  {roleList.map(role => (
                    <option value={role.role_name} selected={updateTaskAssigneeRole==role.role_name?true:false}>{role.role_name}</option>
                  ))}
                </select>
              </div>

              {/* Quick Notification */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_quick_notification">Quick Notification:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_quick_notification"
                  value={addQuickNotification}
                  onChange={(e) => setAddQuickNotification(e.target.value)}
                >
                  <option value="YES" selected={addQuickNotification=="YES"?true:false}>YES</option>
                  <option value="NO" selected={addQuickNotification=="NO"?true:false}>NO</option>
                </select>
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_status">Status:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_status"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="ACTIVE" selected={addStatus=="ACTIVE"?true:false}>ACTIVE</option>
                  <option value="INACTIVE" selected={addStatus=="INACTIVE"?true:false}>INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={showAddValidationError}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add</span>
                      </>
                    )}
                  </Button>

                  {showAddValidationError && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          position: "fixed",
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                          marginTop: "-55px",
                          right: "780px"
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div style={{
                          position: "fixed",
                          backgroundColor: "#C21E22",
                          color: "#FFF",
                          padding: "5px",
                          borderRadius: "4px",
                          zIndex: 20,
                          marginTop: "-55px",
                          right: "550px"
                        }}>
                          <ul className="mb-0 px-4">
                            {addValidationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TaskMaster;
